module.exports = __webpack_public_path__ + "img/bg-servicios-1.727a8050.png";